export default "__VITE_ASSET__Dow3IK9___"